import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {RepositoryModel} from '../network/repository.model';
import {NetworkComponent} from '../network/network.component';
import {AlertService} from '../widgets/alert/alert.service';
import {TranslateService} from '@ngx-translate/core';
import {Repository} from '../network/repository.enum';
import {RepositoryService} from '../core/ecv-http-services/services/repository.service';
import {GoogleScholarPublicationModel} from './google-scholar-publication.model';
import {PublicationService} from '../core/ecv-http-services/services/publication.service';
import {PublicationModel} from '../network/publication.model';
import DateUtils from '../shared/date-utils';
import {AlertUtils} from '@widgets/../shared/AlertUtils';

@Component({
  selector: 'app-dialog-google-scholar-publications',
  templateUrl: './dialog.google-scholar-publications.component.html'
})
export class DialogGoogleScholarPublicationsComponent {
  profiles: GoogleScholarPublicationModel[] = [];
  parent: NetworkComponent;

  constructor(public activeModal: NgbActiveModal,
              private translateService: TranslateService,
              private publicationService: PublicationService,
              private alertService: AlertService) {
  }

  private dismiss(reason: string) {
    this.activeModal.dismiss(reason);
  }

  private addPublicationFromModel(publication: GoogleScholarPublicationModel) {
    const newPublication: PublicationModel = new PublicationModel();
    newPublication.userId = this.parent.userId;
    newPublication.name = publication.title;
    newPublication.descriptionEn = publication.excerpt;
    newPublication.publicationDate.dateFormat = DateUtils.parseDateFormat(publication.year);
    newPublication.publicationDate.date = publication.year;
    this.publicationService.createPublication(newPublication).subscribe(
      response => {
        this.parent.publications.push(newPublication);
        publication.wasAdded = true;
        AlertUtils.showAlert(true, 'ALERT.GITHUB_PROFILE_SAVED', this.translateService, this.alertService);
      }
    );
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/dialog/dialog.google-scholar-publications.component.ts